import { Typography } from '@mui/material';
import FieldNames from '../defaults/FieldNames.json';
import FeatureService from '../services/FeatureService';

export function getAllFinalResults(allFinalResults, finalResults, isAll, costFieldName, acresFieldName) {
  const contributedLines = finalResults.filter(si => (si[FieldNames.featureFields.fundingSourceCategory] && 
    si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.contributed)));
  const bilLines = finalResults.filter(si => (si[FieldNames.featureFields.fundingSourceCategory] && 
    !si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.contributed) && 
    si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.bil)));
  const nonBilLines = finalResults.filter(si => (si[FieldNames.featureFields.fundingSourceCategory] && 
    !si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.contributed) && 
    !si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.bil)));
  const contributedCost = (contributedLines && contributedLines.length) ? contributedLines.map(x => x[costFieldName]) : [0];
  const totalCostBIL = (bilLines && bilLines.length) ? bilLines.map(x => x[costFieldName]) : [0];
  const totalCostNonBIL = (nonBilLines && nonBilLines.length) ? nonBilLines.map(x => x[costFieldName]) : [0];
  const totalCost = (finalResults && finalResults.length) ? finalResults.map(x => x[costFieldName]) : [0];
  const totalBILAcres = (bilLines && bilLines.length) ? bilLines.map(x => x[acresFieldName]) : [0];
  const totalBILNonAcres = (nonBilLines && nonBilLines.length) ? nonBilLines.map(x => x[acresFieldName]) : [0];
  const totalAcres = (finalResults && finalResults.length) ? finalResults.map(x => x[acresFieldName]) : [0];
  if(!isAll){
    allFinalResults.AllEstimatedTotalCostContributed = contributedCost;
    allFinalResults.AllEstimatedTotalCostBIL = totalCostBIL;
    allFinalResults.AllEstimatedTotalCostNonBIL = totalCostNonBIL;
    allFinalResults.AllEstimatedTotalCost = totalCost;
    allFinalResults.AllEstimatedBILAcres = totalBILAcres;
    allFinalResults.AllEstimatedNonBILAcres = totalBILNonAcres;
    allFinalResults.AllEstimatedTotalAcres = totalAcres;
  }
  return allFinalResults;
}

// TODO: Currently unused. Delete by 1.8 if no use case found.
export async function getAllEstimatedFeaturesForApproved(definitionExpression, currentMapExtent, chosenDate, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, isValidationChecked=true) {
  const baseWhere = getApprovedBaseWhere(isValidationChecked, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, definitionExpression, chosenDate);
  return await FeatureService.getAllEstimatedFeatureByDateExpressionUntilDone(currentMapExtent, FieldNames.joinFeatureValues.polygon, baseWhere, "estimate", true).then((features) => {
    return(features);
  }).catch((e) => {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  })
}

export function getApprovedBaseWhere(isValidationChecked, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, definitionExpression, chosenDate){
  const approvalWhereArray = [];
    if(isValidationChecked){
      if(isLocalDateChecked){
        //If Region is checked we are setting both local and region and don't need to check local against region dates
        if(!isRegionDateChecked){
          approvalWhereArray.push(`(COALESCE(${FieldNames.featureFields.regionalApprovalDate}, date '${chosenDate}') >= date '${chosenDate}')`);
        }
      } 
      
      if(isDepartmentDateChecked){
        //If Agency is checked we setting both department and agency and don't need to check department against agency dates
        if(!isAgencyDateChecked){
          approvalWhereArray.push(`(COALESCE(${FieldNames.featureFields.agencyApprovalDate}, date '01-01-1977') <= date '${chosenDate}')`);
        }
      } 
      
      if(isRegionDateChecked){
        if(!isLocalDateChecked){
          approvalWhereArray.push(`(COALESCE(${FieldNames.featureFields.localApprovalDate}, date '01-01-1977') <= date '${chosenDate}')`);
        }

        if(!isAgencyDateChecked){
          approvalWhereArray.push(`(COALESCE(${FieldNames.featureFields.agencyApprovalDate}, date '${chosenDate}') >= date '${chosenDate}')`);
        }
      } 

      if(isAgencyDateChecked){
        if(!isRegionDateChecked){
          approvalWhereArray.push(`(COALESCE(${FieldNames.featureFields.regionalApprovalDate}, date '01-01-1977') <= date '${chosenDate}')`);
        }

        if(!isDepartmentDateChecked){
          approvalWhereArray.push(`(COALESCE(${FieldNames.featureFields.departmentApprovalDate}, date '${chosenDate}') >= date '${chosenDate}')`);
        }
      }
    }

    const approvalWhere = (approvalWhereArray && approvalWhereArray.length) ? approvalWhereArray.join(" AND ") : '';
    const baseWhere = approvalWhere ? `OBJECTID IS NOT NULL AND ${definitionExpression} AND ${approvalWhere}` : `OBJECTID IS NOT NULL AND ${definitionExpression}`;
    return baseWhere;
}

// TODO: Currently unused. Delete by 1.8 if no use case found.
export async function getAllSelectedTotalsForApproved(definitionExpression, currentMapExtent, chosenDate, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, isValidationChecked=true){
  const baseWhere = getApprovedBaseWhere(isValidationChecked, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, definitionExpression, chosenDate);
  return await FeatureService.getAllFeatureEstimatedTotalCostUntilDoneWithinGeo(currentMapExtent, FieldNames.joinFeatureValues.polygon, baseWhere, "estimate", true).then((featureCosts) => {
    return(featureCosts);
  }).catch((e) => {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  })
}

// TODO: Currently unused. Delete by 1.8 if no use case found.
export async function getAllEstimatedFeaturesForReqUnapproval(definitionExpression, currentMapExtent) {
  const baseWhere = getReqUnapprovedBaseWhere(definitionExpression);
  return await FeatureService.getAllEstimatedFeatureByDateExpressionUntilDone(currentMapExtent, FieldNames.joinFeatureValues.polygon, baseWhere, "estimate", true).then((features) => {
    return features;
  }).catch((e) => {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  })
}

export function getReqUnapprovedBaseWhere(definitionExpression){
  const approvalWhere = `(${FieldNames.featureFields.regionalApprovalDate} IS NOT NULL OR ${FieldNames.featureFields.agencyApprovalDate} IS NOT NULL OR ${FieldNames.featureFields.departmentApprovalDate} IS NOT NULL)`;
  const baseWhere = `OBJECTID IS NOT NULL AND ${definitionExpression} AND UnApprovalDate IS NULL AND ${approvalWhere}`;
  return baseWhere;
}

// TODO: Currently unused. Delete by 1.8 if no use case found.
export async function getAllSelectedTotalsForReqUnapproved(definitionExpression, currentMapExtent){
  const baseWhere = getReqUnapprovedBaseWhere(definitionExpression);
  return await FeatureService.getAllFeatureEstimatedTotalCostUntilDoneWithinGeo(currentMapExtent, FieldNames.joinFeatureValues.polygon, baseWhere, "estimate", true).then((featureCosts) => {
    return featureCosts;
  }).catch((e) => {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  })
  
}

// TODO: Currently unused. Delete by 1.8 if no use case found.
export async function getAllEstimatedFeaturesForUnapproved(definitionExpression, currentMapExtent, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, isValidationChecked=true) {
  const baseWhere = getUnapprovedBaseWhere(isValidationChecked, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, definitionExpression);
  return await FeatureService.getAllEstimatedFeatureByDateExpressionUntilDone(currentMapExtent, FieldNames.joinFeatureValues.polygon, baseWhere, "estimate", true).then((features) => {
    return features;
  }).catch((e) => {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  })
}

export function getUnapprovedBaseWhere(isValidationChecked, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, definitionExpression) {
  const approvalWhereArray = [];
  if(isValidationChecked){
    if(isLocalDateChecked){
      approvalWhereArray.push(`${FieldNames.featureFields.localApprovalDate} IS NOT NULL`);
    } 
    
    if(isDepartmentDateChecked){
        approvalWhereArray.push(`${FieldNames.featureFields.departmentApprovalDate} IS NOT NULL`);
    } 
    
    if(isRegionDateChecked){
        approvalWhereArray.push(`${FieldNames.featureFields.regionalApprovalDate} IS NOT NULL`);
    } 

    if(isAgencyDateChecked){
      approvalWhereArray.push(`${FieldNames.featureFields.agencyApprovalDate} IS NOT NULL`);
    }
  }

  const approvalWhere = (approvalWhereArray && approvalWhereArray.length) ? `(${approvalWhereArray.join(" OR ")})` : null;
  const baseWhere = approvalWhere ? `OBJECTID IS NOT NULL AND ${definitionExpression} AND ${approvalWhere}` : `OBJECTID IS NOT NULL AND ${definitionExpression}`;
  return baseWhere;
}

// TODO: Currently unused. Delete by 1.8 if no use case found.
export async function getAllSelectedTotalsForUnapproved(definitionExpression, currentMapExtent, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, isValidationChecked=true){
  const baseWhere = getUnapprovedBaseWhere(isValidationChecked, isLocalDateChecked, isRegionDateChecked, isAgencyDateChecked, isDepartmentDateChecked, definitionExpression);
  return await FeatureService.getAllFeatureEstimatedTotalCostUntilDoneWithinGeo(currentMapExtent, FieldNames.joinFeatureValues.polygon, baseWhere, "estimate", true).then((featureCosts) => {
    return (featureCosts);
  }).catch((e) => {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  })
}

// TODO: Currently unused. Delete by 1.8 if no use case found.
export async function getEstimatedTotalCostsForFeaturesWithinExtent (definitionExpression, currentMapExtent) {
  return await FeatureService.getAllFeatureEstimatedTotalCostUntilDoneWithinGeo(currentMapExtent, FieldNames.joinFeatureValues.polygon, definitionExpression, "estimate", true).then((featureCosts) => {
    return(featureCosts);
  }).catch((e) => {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  })
}

export async function getEstimatedTotalCostsForFeatures (definitionExpression) {
  return await FeatureService.getAllFeatureEstimatedTotalCostUntilDone(definitionExpression, "estimate").then((featureCosts) => {
    return(featureCosts);
  }).catch((e) => {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  })
}

export function displayBulkApprovalFilterWarning (setAlertMessageObj, handleClose)
{
  setAlertMessageObj({
    title: "Filter Error",
    severity: "error",
    child: (
      <Typography sx={{ marginLeft: "5px", marginRight: "5px" }}>
        You must have at least one funding org filter applied to access Bulk Approval.
      </Typography>
    ),
    callback: handleClose
  });
}
